import { jsPDF } from 'jspdf'
import { toCanvas } from 'html-to-image';
import camelCaseToSentenceCase from './camelToSentence';

export default function htmlToPdf(html, filename, type) {
    try {
        console.log(html)
        const pdf = new jsPDF('l', 'pt', 'a4', true)
        const elements = html.getElementsByTagName('img');
        while (elements[0])
            elements[0].parentNode.removeChild(elements[0])
        toCanvas(html).then(ca => {
            pdf.lineHeightProportion = 2;
            pdf.text(camelCaseToSentenceCase(filename), 10, 100)
            pdf.line(10, 120, pdf.internal.pageSize.getWidth() - 10, 125);

            pdf.addImage(ca.toDataURL('image/png'), 'PNG', 10, 130, pdf.internal.pageSize.getWidth() - 10, 350, 'FAST')
            if (type === 'save') pdf.save(`${filename}.pdf`)
            if (type === 'view') pdf.output('dataurlnewwindow');
        })
    } catch (error) {
        console.log(error)
    }
}